import { useCallback, useEffect, useState } from "react";
import type { ProfilePhotoDto, ViewerProfilePhotoContext } from "@madamuh/domain";
import { fetchViewerProfilePhoto, setViewerProfilePhoto } from "../../api/profilePhoto";

export function useViewerProfilePhoto(tenantSlug: string, viewerContext: ViewerProfilePhotoContext, enabled: boolean) {
  const [photo, setPhoto] = useState<ProfilePhotoDto | null>(null);
  const refresh = useCallback(async () => {
    if (!enabled) return;
    const result = await fetchViewerProfilePhoto(tenantSlug, viewerContext);
    setPhoto(result.profilePhoto);
  }, [enabled, tenantSlug, viewerContext]);
  useEffect(() => { void refresh().catch(() => setPhoto(null)); }, [refresh]);
  const set = useCallback(async (blob: Blob) => {
    if (blob.size > 2 * 1024 * 1024) throw new Error("画像の処理に失敗しました。別の画像を選択してください。");
    const next = await setViewerProfilePhoto(tenantSlug, viewerContext, blob);
    setPhoto(next);
    return next;
  }, [tenantSlug, viewerContext]);
  return { photo, refresh, set };
}
